
















































import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';

@Component({
  components: {
    MainButton,
    LabelSlot,
  },
})
export default class PerformBillingConfirmItensModal extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop({
    required: true,
    type: Array,
    default: () => [],
  })
  numberItemsWithInvoice!: number[];

  loading: boolean = false;

  get message(): string {
    return `
  Os seguintes itens já possuem faturamentos gerados para a competência selecionada:

  Itens: ${this.numberItemsWithInvoice}

  Como você deseja proceder?`.trim();
  }

  cancel() {
    this.$emit('cancel');
  }

  handleExecuteAllItens() {
    this.$emit('executeAllItens');
  }

  handleExecuteItensNotInvoiced() {
    this.$emit('executeItensNotInvoiced');
  }
}
